// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__4ZNid","box":"styles_box__uK3Kb","checked":"styles_checked__Hf7bk"};